import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import { Link } from "react-router-dom";
import React from "react";
import i18next from "i18next";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const Home = () => {
  const { t } = useTranslation();
  const loggedUserReducer = useSelector((state) => state.loggedUserReducer);
  return (
    <div className="home-container-main">
      <div className="home-holder">
        <div className="home-slider-holder">
          <div className="mask-homepage-image"></div>
          <h1 dangerouslySetInnerHTML={{ __html: t("home.welcome_title") }} />
          <img
            src="/images/home-image-1.png"
            className="img-fluid homapage-image-container"
            alt="LG OLED TV"
          />
        </div>
        <div className="home-menu-holder">
          <div className="home-menu-list-items">
            {loggedUserReducer?.loggedUser?.accountType != "MANAGER" &&
              loggedUserReducer?.loggedUser?.companyId !=
                "9d36797c-7a25-432c-9e47-b4b3eb5ba0d6" && (
                <div
                  className={`home-menu-list-item ${
                    i18next.language == "mk" && "mkd-image"
                  }`}
                >
                  <Link to="/catalog/0">
                    <img
                      src="/images/footer1.svg"
                      className={`img-fluid ${
                        i18next.language == "mk" && "mkd-image"
                      }`}
                    />
                    {t("home.saleReport")}
                  </Link>
                </div>
              )}
            <div
              className={`home-menu-list-item ${
                i18next.language == "mk" && "mkd-image"
              }`}
            >
              <Link to="/reward">
                <img src="/images/footer2.svg" className={`img-fluid `} />
                {t("home.order_rewards")}
              </Link>
            </div>
            {loggedUserReducer?.loggedUser?.accountType != "MANAGER" ? (
              <div
                className={`home-menu-list-item ${
                  i18next.language == "mk" && "mkd-image"
                }`}
              >
                <Link to="/order">
                  <img
                    src="/images/footer3.svg"
                    className={`img-fluid ${
                      i18next.language == "mk" && "mkd-image"
                    }`}
                  />
                  {t("home.sales_report")}
                </Link>
              </div>
            ) : (
              <div
                className={`home-menu-list-item ${
                  i18next.language == "mk" && "mkd-image"
                }`}
              >
                <Link to="/user-points">
                  <img
                    src="/images/footer3.svg"
                    className={`img-fluid ${
                      i18next.language == "mk" && "mkd-image"
                    }`}
                  />
                  {t("myProfile.userPointsLink")}
                </Link>
              </div>
            )}
            <div
              className={`home-menu-list-item ${
                i18next.language == "mk" && "mkd-image"
              }`}
            >
              <Link to="/education-list">
                <img
                  src="/images/footer4.svg"
                  className={`img-fluid ${
                    i18next.language == "mk" && "mkd-image"
                  }`}
                />
                {t("home.education_and_trainings")}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
